import { render } from "./ModalItemModifierDetail.vue?vue&type=template&id=3b586c5b&scoped=true"
import script from "./ModalItemModifierDetail.vue?vue&type=script&lang=js"
export * from "./ModalItemModifierDetail.vue?vue&type=script&lang=js"

import "./ModalItemModifierDetail.vue?vue&type=style&index=0&id=3b586c5b&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b586c5b"]])

export default __exports__